import { ReportUpdateConfigFields } from "@entities/reports/ui/ReportUpdateConfigFields";
import {
  getDefaultReportUpdateConfig,
  type ReportUpdateConfigValue,
} from "@entities/reports/lib/utils/reportUpdateConfig";
import { Button } from "@shared/ui";
import { BarChart3, LinkIcon } from "lucide-react";
import { useState } from "react";
import styles from "./BriefReportWaitingState.module.scss";

interface BriefReportWaitingStateProps {
  onCreateReport: (schedule: ReportUpdateConfigValue) => void;
  isCreating: boolean;
}

export function BriefReportWaitingState({
  onCreateReport,
  isCreating,
}: BriefReportWaitingStateProps) {
  const [schedule, setSchedule] = useState(getDefaultReportUpdateConfig);

  const canSubmit =
    Boolean(schedule.updateTillDate) &&
    schedule.updateForIntervalHourFrequency > 0;

  return (
    <div className={styles.waitingState}>
      <div className={styles.iconWrapper}>
        <BarChart3 size={28} className={styles.icon} />
        <div className={styles.iconBadge}>
          <LinkIcon size={12} className={styles.linkIcon} />
        </div>
      </div>

      <h3 className={styles.title}>Waiting for live data</h3>
      <p className={styles.description}>
        Reports generate once live links are added in Execution. Set how long
        and how often this report should update — you can change this until the
        first media is added.
      </p>

      <div className={styles.scheduleCard}>
        <div className={styles.scheduleHeader}>
          <h4 className={styles.scheduleTitle}>Update schedule</h4>
          <p className={styles.scheduleSubtitle}>
            Editable until the first media is tracked.
          </p>
        </div>

        <ReportUpdateConfigFields
          value={schedule}
          onChange={setSchedule}
          compact
        />

        <Button
          type="primary"
          className={styles.createButton}
          disabled={!canSubmit}
          loading={isCreating}
          onClick={() => onCreateReport(schedule)}
        >
          Create Report
        </Button>
      </div>
    </div>
  );
}
